import { createDraftSafeSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GlobalState } from '@store'
import { LoadingState, Resource } from '@types'

interface resourceState {
  loadingStatus: LoadingState
  message: string
  resources: Resource[]
}

const initialState: resourceState = {
  loadingStatus: 'NOT_STARTED',
  message: '',
  resources: []
}

export type resourceAction = PayloadAction<Resource>

const resourceSlice = createSlice({
  name: 'resource',
  initialState,

  reducers: {
    getResources: state => {
      return {
        ...state,
        loadingStatus: 'LOADING'
      }
    },
    createResource: (state, _action: PayloadAction<Resource>) => {
      return {
        ...state,
        loadingStatus: 'LOADING'
      }
    },
    createResourceSuccess: (state, action: PayloadAction<Resource>) => {
      const resources = [...state.resources]
      resources.push(action.payload)
      return {
        ...state,
        loadingStatus: 'SUCCESS',
        resources
      }
    },
    deleteResource: (state, _action: PayloadAction<string>) => {
      return {
        ...state,
        loadingStatus: 'LOADING'
      }
    },
    deleteResourceSucces: (state, action: PayloadAction<string>) => {
      const resources = [...state.resources]
      const deletedIdx = resources.findIndex(res => res._id === action.payload)
      resources.splice(deletedIdx, 1)
      return {
        ...state,
        loadingState: 'SUCCESS',
        resources
      }
    },
    resourceSuccess: (state, action: PayloadAction<Resource[]>) => {
      return {
        ...state,
        loadingStatus: 'SUCCESS',
        resources: action.payload
      }
    },
    resourceFailed: (state, action) => {
      return {
        ...state,
        loadingStatus: 'FAILED',
        message: action.payload
      }
    },
    clearresource: _state => {
      return initialState
    }
  }
})

export const resourceLoader = createDraftSafeSelector(
  [(state: GlobalState) => state.resources.loadingStatus, (state: GlobalState) => state.resources.message],
  (loadingStatus, message) => {
    const isLoading = loadingStatus === 'LOADING'
    const isFailed = loadingStatus === 'FAILED'
    const isSuccess = loadingStatus === 'SUCCESS'
    return { isLoading, isFailed, isSuccess, message }
  }
)

export const selectResources = createDraftSafeSelector(
  [(state: GlobalState) => state.resources.resources],
  resources => resources
)

export const {
  getResources,
  createResource,
  resourceSuccess,
  resourceFailed,
  deleteResource,
  deleteResourceSucces,
  clearresource,
  createResourceSuccess
} = resourceSlice.actions
export default resourceSlice.reducer
